import { ProgressState } from '../types/reducers/progress'
import {
    SET_BULK_ACTION_PROGRESS,
    SET_RECIPE_PROGRESS,
    SetBulkActionProgress,
    SetRecipeProgress,
} from '../constants/reducers/progress'
import { Action } from '../constants/reducers/state'

export const ProgressInitialState: ProgressState = {
    bulk_actions: {},
    recipes: {},
}

export const progressReducer = (state: ProgressState, action: Action): ProgressState => {
    if (typeof state === 'undefined') {
        return ProgressInitialState
    }

    switch (action.type) {
        case SET_BULK_ACTION_PROGRESS:
            // console.log('ba progress is', state, action)
            if (
                Object.keys(state.bulk_actions).length == 0 &&
                Object.keys(action.progress).length == 0
            ) {
                return state
            }
            return Object.assign({}, state, {
                bulk_actions: action.progress,
            })
        case SET_RECIPE_PROGRESS:
            return Object.assign({}, state, {
                recipes: action.progress,
            })
        default:
            return state
    }
}
